import { Select } from "antd";
import { useGetRolesQuery } from "api/TenantSlug/Role/hooks.ts";
import { SearchableSelectWrapperProps } from "components/UI/Selects/SearchableSelect/SearchableSelect.tsx";
import { UserSelectSearchable } from "components/UI/Selects/UserSelectSearchable/UserSelectSearchable.tsx";
import { RoleEnum } from "types/enums";

export const AdvertiserSelectSearchable = (props: SearchableSelectWrapperProps) => {
    const { data: rolesData, isLoading } = useGetRolesQuery({});

    const advertiserRole = rolesData?.roles.find((r) => r.name === RoleEnum.Advertiser);

    // Wait for roles to load before rendering UserSelectSearchable
    // This prevents the race condition where UserSelectSearchable would load all users
    if (isLoading || !advertiserRole?.id) {
        return <Select {...props} loading disabled size={props.size ?? "middle"} />;
    }

    return <UserSelectSearchable roleId={advertiserRole.id} {...props} />;
};
